import { useHttp } from "../services/HttpService";
import { ASC, sortBy } from "./ArrayUtils";
import { useEffect, useRef, useState } from "react";

/**
 * Hook, welcher einen Endpoint abfragt und die Daten abgewandelt zurückgibt.
 * @param preformatData Funktion, welche die kommenden Daten abwandelt.
 * @param config config oder Url für den useHttp-Hook
 * @param options Optionen für den useHttp-Hook
 */
export function usePreformattedHttp(preformatData, config, options) {
    const [httpData, refetch] = useHttp(config, options);

    const preformatFunc = useRef(preformatData);

    const [sortedData, setSortedData] = useState([]);

    useEffect(() => {
        setSortedData(httpData.data ? preformatFunc.current(httpData.data) : httpData.data);
    }, [httpData.data]);

    return [{ data: sortedData, loading: httpData.loading, error: httpData.error, response: httpData.response }, refetch];
}

/**
 * Nutzt den usePreformattedHttp-Hook, um die Daten vom Endpoint wahlweise auf- oder absteigend sortiert abzufragen
 * @param config
 * @param options
 * @param orderBy
 */
export function useHttpSortById(config, options, orderBy = ASC) {
    return usePreformattedHttp((data) => sortBy(data, orderBy), config, options);
}
